import React from 'react';

const DashboardHeader = ({ business }) => {
	return (
		<div className='dashboard-header'>
			<div>
				<h1 className='dashboard-header__title'>
					Welcome back, {business?.businessName || 'Business'}
				</h1>
				<p className='dashboard-header__subtitle'>
					Here is a snapshot of your business activity, local reach, and offers.
				</p>
			</div>
		</div>
	);
};

export default DashboardHeader;
